import { useQuery } from '@tanstack/react-query';
import { fetchChatbotSettings } from './request';
import { CHATBOT_SETTINGS_QUERY_KEY } from './key';

export const useChatbotSettings = () => {
  return useQuery({
    queryKey: [CHATBOT_SETTINGS_QUERY_KEY],
    queryFn: fetchChatbotSettings,
  });
};
